import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { PickItem, PickHead } from 'Components';
import './PickList.css';

const allChecked = list => list.every(x => x.checked);

class PickList extends PureComponent {
  createPickGroup(items, level = 0, indices = []) {
    const pickItems = items.map((item, n) => {
      const indecesNext = [...indices, n];
      return (
        <Fragment key={item.key}>
          <div
            onClick={e => this.handleClick(e, indecesNext, 'collapsed')}
            onKeyPress={e => (e.key === 'Enter') && this.handleClick(e, indecesNext, 'collapsed')}
            role="button"
            tabIndex="0"
            className="pick-list__options__option"
          >
            <PickItem
              title={item.title}
              subtitle={item.subtitle}
              checked={item.checked}
              collapsed={item.collapsed}
              hasChildren={item.children.length > 0}
              onClick={e => this.handleClick(e, indecesNext, 'checked')}
            />
          </div>
          { !item.collapsed && this.createPickGroup(item.children, level + 1, indecesNext)}
        </Fragment>
      );
    });

    return (
      <div className={`pick-list__level--${level}`}>
        { ((pickItems.length > 0) && (this.props.selectAlls[level])) &&
          <PickHead
            checked={allChecked(items)}
            onClick={() => this.handleToggleAll(indices)}
          /> }
        {pickItems}
      </div>);
  }

  handleClick(e, indices, prop) {
    e.stopPropagation();

    const items = [...this.props.items];
    let obj = items[indices.shift()];
    indices.forEach((index) => { obj = obj.children[index]; });

    obj[prop] = !obj[prop];

    this.props.setParentState(items);
  }

  handleToggleAll(indices) {
    const obj = [...this.props.items];
    let items = obj;

    indices.forEach((index) => { items = items[index].children; });
    const checked = allChecked(items);

    items.forEach((item, i) => {
      items[i].checked = !checked;
    });

    this.props.setParentState(obj);
  }

  render() {
    return (
      <div className="pick-list">
        { this.props.title && <div className="pick-list__title">{this.props.title}</div> }
        <ul className="pick-list__options">
          { this.createPickGroup(this.props.items) }
        </ul>
      </div>);
  }
}

const nodeShape = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  key: PropTypes.string,
  checked: PropTypes.bool,
  collapsed: PropTypes.bool,
};
nodeShape.children = PropTypes.arrayOf(PropTypes.shape(nodeShape));

PickList.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape(nodeShape)),
  selectAlls: PropTypes.arrayOf(PropTypes.bool),
  setParentState: PropTypes.func,
};

PickList.defaultProps = {
  items: [],
};

export default PickList;



// WEBPACK FOOTER //
// ./src/components/PickList/PickList.jsx